<mat-toolbar color="primary" div fxLayout="row" fxLayoutAlign="space-between center" >
    <a [routerLink]="['/home']"><img src="../../../assets/images/logo_econocom_white.svg" fxFlex="258px" fxFlex.lt-sm="150px"/></a>
    <div>
        <button mat-button [matMenuTriggerFor]="menu">
            <img [src]="this.selectedLanguage.image" width="25"  class="languageImage"/> 
            <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button *ngFor="let language of this.languages" (click)="switchLang(language.shortName)" mat-menu-item fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <img [src]="language.image" width="25"  class="languageImage"/> 
                {{ language.longName }}
            </button>
          </mat-menu>
    </div>
</mat-toolbar>
